var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8492 6.56521C16.6844 5.95325 16.2019 5.47074 15.59 5.30598C14.472 5 9.99993 5 9.99993 5C9.99993 5 5.5279 5 4.40989 5.29421C3.80969 5.45897 3.31542 5.95325 3.15066 6.56521C2.85645 7.68322 2.85645 10.0016 2.85645 10.0016C2.85645 10.0016 2.85645 12.3318 3.15066 13.438C3.31542 14.05 3.79793 14.5325 4.40989 14.6973C5.53967 15.0032 9.99993 15.0032 9.99993 15.0032C9.99993 15.0032 14.472 15.0032 15.59 14.709C16.2019 14.5443 16.6844 14.0618 16.8492 13.4498C17.1434 12.3318 17.1434 10.0134 17.1434 10.0134C17.1434 10.0134 17.1552 7.68322 16.8492 6.56521Z",
    fill: "#1F1F23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57593 12.1436L12.2948 10.0017L8.57593 7.85986V12.1436Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.52c201da0186a98541dbafc057515d93.svg";
export { ForwardRef as ReactComponent };